<template>
  <div>
    <div class="relative" style="height: 70vh;">
      <!-- Background image -->
      <div class="absolute inset-0">
        <img src="@/assets/images/testing.png" alt="University Background" class="object-cover w-full h-full" />
        <div class="absolute inset-0 bg-black opacity-50"></div> <!-- Dark overlay -->
      </div>

      <!-- Content over the image -->
      <div class="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center text-white">
        <br><br><br><br>
        <h2 class="mb-4 text-4xl font-bold md:text-5xl">Start Your Journey!</h2>

        <!-- Form -->
        <div class="flex w-full max-w-3xl p-2 px-4 space-x-4 rounded-full shadow-lg journey_div">
          <!-- Study level dropdown -->
          <select class="flex-1 px-4 py-2 border-none rounded-full form-select focus:ring-0 focus:outline-none">
            <option>Study level</option>
            <option>Bachelor's</option>
            <option>Master's</option>
            <option>PhD</option>
          </select>

          <!-- Study destination dropdown -->
          <select class="flex-1 px-4 py-2 border-none rounded-full form-select focus:ring-0 focus:outline-none">
            <option>Study destination</option>
            <option>USA</option>
            <option>UK</option>
            <option>Australia</option>
          </select>

          <!-- Subject dropdown -->
          <select class="flex-1 px-4 py-2 border-none rounded-full form-select focus:ring-0 focus:outline-none">
            <option>Subject</option>
            <option>Engineering</option>
            <option>Business</option>
            <option>Science</option>
          </select>

          <!-- Search Button -->
          <button
            class="flex items-center px-8 py-2 text-white transition duration-300 rounded-full bg-purple hover:bg-purple-800">
            Search
            <i class="ml-2 fas fa-search"></i>
          </button>
        </div>
      </div>

    </div>
    <div class="flex justify-center w-full text-white bg-purple">
      <div class="py-5 text-center">
        <h5 class="">ABOUT US</h5>
        <div class="w-16 mx-auto mb-4 border-b-2 border-white"></div>
        <p class="w-3/5 mx-auto my-2 leading-normal text-center">Lorem ipsum dolor, sit amet consectetur adipisicing
          elit. Numquam, rerum
          culpa rem perferendis, fugiat minima non voluptatibus sequi voluptates quos corporis quisquam labore, eius
          reiciendis et? Doloremque unde reprehenderit voluptatum!</p>
        <button class="bg-white text-purple py-1.5 px-4 rounded-full text-sm font-bold hover:bg-gray-100 shadow-md">
          Learn More
        </button>
      </div>
    </div>

    <section class="py-12 my-4">
      <div class="container mx-auto text-center">
        <h3 class="">Explore Our Universities</h3>
        <hr class="mx-auto mb-8 border-purple w-72" style=" border-top-width: 3px !important;">
        <!-- <div class="w-16 mx-auto mb-4 border-b-2 border-white"></div> -->
        <!-- Card Grid -->
        <div class="grid grid-cols-1 gap-8 px-16 md:grid-cols-3">
          <!-- Card 1 -->
          <div class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img src="@/assets/images/uni1.png" alt="University 1" class="object-cover w-full h-48">
            <div class="p-6 bg-lightPurple">
              <hr class="w-64 mx-auto mb-2 border-purple below_line">
              <h3 class="mb-2 text-lg font-semibold">Lorem Ipsum</h3>
              <p class="mb-4 text-gray-600">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.
              </p>
              <button
                class="px-6 py-2 text-white transition duration-300 bg-purple-700 rounded-full hover:bg-purple-800">
                Learn More
              </button>
            </div>
          </div>

          <!-- Card 2 -->
          <div class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img src="@/assets/images/uni2.png" alt="University 2" class="object-cover w-full h-48">
            <div class="p-6 bg-lightPurple">
              <hr class="w-64 mx-auto mb-2 border-purple below_line">
              <h3 class="mb-2 text-lg font-semibold">Lorem Ipsum</h3>
              <p class="mb-4 text-gray-600">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.
              </p>
              <button
                class="px-6 py-2 text-white transition duration-300 bg-purple-700 rounded-full hover:bg-purple-800">
                Learn More
              </button>
            </div>
          </div>

          <!-- Card 3 -->
          <div class="overflow-hidden bg-white rounded-lg shadow-lg">
            <img src="@/assets/images/uni3.png" alt="University 3" class="object-cover w-full h-48">
            <div class="p-6 bg-lightPurple">
              <hr class="w-64 mx-auto mb-2 border-purple below_line">
              <h3 class="mb-2 text-lg font-semibold">Lorem Ipsum</h3>
              <p class="mb-4 text-gray-600">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.
              </p>
              <button
                class="px-6 py-2 text-white transition duration-300 bg-purple-700 rounded-full hover:bg-purple-800">
                Learn More
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="py-12 bg-lightPurple">
      <div class="container mx-auto">
        <h3 class="text-center">HOW MUO CAN SUPPORT YOU?</h3>
        <hr class="mx-auto mb-4 border-purple w-96" style=" border-top-width: 3px !important;">

        <div class="w-3/5 mx-auto mb-8 text-center">
          <p>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Eligendi enim vel libero, voluptatum dolorum
            impedit facere error praesentium ad laborum ab aliquid eaque soluta temporibus placeat rerum esse recusandae
            provident?
          </p>
        </div>
        <div class="relative">
          <!-- Vertical Line -->
          <div class="absolute w-1 transform -translate-x-1/2 bg-purple h-96 mt-7 left-1/2"></div>

          <!-- Timeline Item 2 (Right) -->
          <div class="flex items-center justify-between w-full mb-8">
            <div class="w-5/12"></div>
            <div class="relative flex justify-center w-1/12">
              <div class="relative">
                <div class="absolute w-8 h-1 transform -translate-y-1/2 top-1/2 -right-8 bg-purple"></div>
                <div class="w-6 h-6 border-4 rounded-full bg-purple border-lightPurple"></div>
              </div>
            </div>
            <div class="w-5/12 pl-8">
              <h3 class="text-lg font-semibold">Lorem Ipsum</h3>
              <p class="text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua.</p>
            </div>
          </div>

          <!-- Timeline Item 1 (Left) -->
          <div class="flex items-center justify-between w-full mb-8">
            <div class="w-5/12 pr-8 text-right">
              <h3 class="text-lg font-semibold">Lorem Ipsum</h3>
              <p class="text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua.</p>
            </div>
            <div class="relative flex justify-center w-1/12">
              <div class="relative">
                <div class="absolute w-8 h-1 transform -translate-y-1/2 top-1/2 -left-8 bg-purple"></div>
                <div class="w-6 h-6 border-4 rounded-full bg-purple border-lightPurple"></div>
              </div>
            </div>
            <div class="w-5/12"></div>
          </div>

          <!-- Timeline Item 4 (Right) -->
          <div class="flex items-center justify-between w-full mb-8">
            <div class="w-5/12"></div>
            <div class="relative flex justify-center w-1/12">
              <div class="relative">
                <div class="absolute w-8 h-1 transform -translate-y-1/2 top-1/2 -right-8 bg-purple"></div>
                <div class="w-6 h-6 border-4 rounded-full bg-purple border-lightPurple"></div>
              </div>
            </div>
            <div class="w-5/12 pl-8">
              <h3 class="text-lg font-semibold">Lorem Ipsum</h3>
              <p class="text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua.</p>
            </div>
          </div>
          <!-- Timeline Item 3 (Left) -->
          <div class="flex items-center justify-between w-full mb-8">
            <div class="w-5/12 pr-8 text-right">
              <h3 class="text-lg font-semibold">Lorem Ipsum</h3>
              <p class="text-gray-600">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                incididunt ut labore et dolore magna aliqua.</p>
            </div>
            <div class="relative flex justify-center w-1/12">
              <div class="relative">
                <div class="absolute w-8 h-1 transform -translate-y-1/2 top-1/2 -left-8 bg-purple"></div>
                <div class="w-6 h-6 border-4 rounded-full bg-purple border-lightPurple"></div>
              </div>
            </div>
            <div class="w-5/12"></div>
          </div>


        </div>
      </div>
    </section>




    <section class="py-12 bg-purple-700">
      <div class="container mx-auto">
        <h3 class="text-center text-white">TESTIMONIALS</h3>
        <hr class="w-32 mx-auto mb-4 border-white" style=" border-top-width: 3px !important;">


        <!-- Testimonial Carousel Wrapper -->
        <div class="relative flex items-center justify-center">
          <!-- Left Arrow -->
          <button class="absolute left-0 z-10 text-4xl text-white focus:outline-none" @click="prevSlide">
            &#8249;
          </button>

          <!-- Testimonial Content -->
          <div class="relative flex items-center w-full md:w-3/4">

            <!-- Image Section -->
            <div class="relative w-1/2 h-3/5" style="left:10%;">
              <img class="" src="@/assets/images/testimonial.png" :alt="testimonials[currentSlide].alt"
                style="height:230px;" />
              <div class="absolute text-6xl text-white top-4 left-4">
                &#8220;
              </div>
            </div>

            <!-- Text Section: Positioned from the middle of the image -->
            <div class="relative w-2/5 p-8 rounded bg-lightPurple" style="margin-left: -50px;margin-top:15%;">
              <h3 class="mb-4 text-xl font-semibold text-gray-900">
                {{ testimonials[currentSlide].name }}
              </h3>
              <p class="text-gray-600">
                {{ testimonials[currentSlide].text }}
              </p>
              <div class="absolute text-6xl text-purple-700 bottom-4 right-4">
                &#8221;
              </div>
            </div>
          </div>

          <!-- Right Arrow -->
          <button class="absolute right-0 z-10 text-4xl text-white focus:outline-none" @click="nextSlide">
            &#8250;
          </button>

        </div>
      </div>
    </section>






  </div>


</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      currentSlide: 0,
      testimonials: [
        {
          name: "John Doe",
          text: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua.",
          image: "https://via.placeholder.com/400",
          alt: "John Doe Testimonial"
        },
        {
          name: "Jane Smith",
          text: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua.",
          image: "https://via.placeholder.com/400",
          alt: "Jane Smith Testimonial"
        },
        {
          name: "Emily Johnson",
          text: "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua.",
          image: "https://via.placeholder.com/400",
          alt: "Emily Johnson Testimonial"
        }
      ]
    };
  },
  methods: {
    nextSlide() {
      this.currentSlide =
        (this.currentSlide + 1) % this.testimonials.length;
    },
    prevSlide() {
      this.currentSlide =
        (this.currentSlide - 1 + this.testimonials.length) %
        this.testimonials.length;
    }
  }
}
</script>

<style scoped>
.journey_div {
  background: transparent;
  border: 2px solid #fff;
}

.below_line {
  font-weight: bold;
  border-top-width: 2px !important;
}

.form-select {
  appearance: none;
  background: transparent;
  color: #fff;
  padding: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}

.bg-lightPurple {
  background-color: #f3e1f5;
}

.bg-purple-700 {
  background-color: #800080;
}

.bg-purple-800 {
  background-color: #660066;
}

.shadow-lg {
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.1);
}
</style>